import { useMemo } from "react"
import {
  Block,
  BlockProps,
  HeadingSmall,
  ListItem,
  ListItemLabel,
  useStyletron,
} from "@mezo-org/mezo-clay"

type OverviewSectionProps = BlockProps & {
  header: string
  isLoading: boolean
}

export default function OverviewSection({
  header,
  children,
  isLoading,
  ...props
}: OverviewSectionProps) {
  const [, theme] = useStyletron()

  const content = useMemo(
    () =>
      isLoading ? (
        <ListItem state="loading" endEnhancer={() => null}>
          <ListItemLabel description={<Block />}>{null}</ListItemLabel>
        </ListItem>
      ) : (
        children
      ),
    [isLoading, children],
  )

  return (
    <Block paddingTop={theme.sizing.scale1000} {...props}>
      <HeadingSmall marginBottom={theme.sizing.scale600}>{header}</HeadingSmall>
      {content}
    </Block>
  )
}
